/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { ConfigDtoGenericResponse } from '../models/config-dto-generic-response';
import { TableSectionDtoArrayGenericResponse } from '../models/table-section-dto-array-generic-response';

@Injectable({ providedIn: 'root' })
export class SettingsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiV1SettingsGet()` */
  static readonly ApiV1SettingsGetPath = '/api/v1/settings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1SettingsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1SettingsGet$Plain$Response(
    params?: {
      'X-Bypass-Cache'?: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<ConfigDtoGenericResponse>> {
    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiV1SettingsGetPath, 'get');
    if (params) {
      rb.header('X-Bypass-Cache', params['X-Bypass-Cache'], {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ConfigDtoGenericResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1SettingsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1SettingsGet$Plain(
    params?: {
      'X-Bypass-Cache'?: boolean;
    },
    context?: HttpContext
  ): Observable<ConfigDtoGenericResponse> {
    return this.apiV1SettingsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ConfigDtoGenericResponse>): ConfigDtoGenericResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1SettingsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1SettingsGet$Json$Response(
    params?: {
      'X-Bypass-Cache'?: boolean;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<ConfigDtoGenericResponse>> {
    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiV1SettingsGetPath, 'get');
    if (params) {
      rb.header('X-Bypass-Cache', params['X-Bypass-Cache'], {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ConfigDtoGenericResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1SettingsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1SettingsGet$Json(
    params?: {
      'X-Bypass-Cache'?: boolean;
    },
    context?: HttpContext
  ): Observable<ConfigDtoGenericResponse> {
    return this.apiV1SettingsGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ConfigDtoGenericResponse>): ConfigDtoGenericResponse => r.body)
    );
  }

  /** Path part for operation `apiV1SettingsSectionsStoreIdGet()` */
  static readonly ApiV1SettingsSectionsStoreIdGetPath = '/api/v1/settings/sections/{storeId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1SettingsSectionsStoreIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1SettingsSectionsStoreIdGet$Plain$Response(
    params: {
      storeId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<TableSectionDtoArrayGenericResponse>> {
    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiV1SettingsSectionsStoreIdGetPath, 'get');
    if (params) {
      rb.path('storeId', params.storeId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TableSectionDtoArrayGenericResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1SettingsSectionsStoreIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1SettingsSectionsStoreIdGet$Plain(
    params: {
      storeId: number;
    },
    context?: HttpContext
  ): Observable<TableSectionDtoArrayGenericResponse> {
    return this.apiV1SettingsSectionsStoreIdGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<TableSectionDtoArrayGenericResponse>): TableSectionDtoArrayGenericResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1SettingsSectionsStoreIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1SettingsSectionsStoreIdGet$Json$Response(
    params: {
      storeId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<TableSectionDtoArrayGenericResponse>> {
    const rb = new RequestBuilder(this.rootUrl, SettingsService.ApiV1SettingsSectionsStoreIdGetPath, 'get');
    if (params) {
      rb.path('storeId', params.storeId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TableSectionDtoArrayGenericResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1SettingsSectionsStoreIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1SettingsSectionsStoreIdGet$Json(
    params: {
      storeId: number;
    },
    context?: HttpContext
  ): Observable<TableSectionDtoArrayGenericResponse> {
    return this.apiV1SettingsSectionsStoreIdGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<TableSectionDtoArrayGenericResponse>): TableSectionDtoArrayGenericResponse => r.body)
    );
  }

}
